module.exports = __webpack_public_path__ + "static/media/manual-import-card.4fe6d4d9.png";